import React, { useState, useEffect, useContext, useCallback } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
  Box,
  ModalHeader,
  FormControl,
  FormLabel,
  Input,
  Heading,
  Accordion,
  AccordionButton,
  AccordionItem,
  AccordionPanel,
  AccordionIcon,
  useBreakpointValue,
} from "@chakra-ui/react";
import { appRequest } from "routes";
import FileViewer from "components/common/FileViewerPdfAndImage/FileViewer";
import { capitalizeCharAndAddSpace } from "components/common/functions/commonFunctions";
// import { CheckIcon, CloseIcon } from "@chakra-ui/icons";
import { AppContext } from "AppProvider/AppContext";
import CurbeyTable from "./CurbeyTable";
// import ItemsModal from "./PurchaseOrder/ItemsModal";

type ModalProps = {
  isOpen: boolean;
  onClose: () => void;
  file: any;
};

export default function ViewerModal({
  isOpen,
  onClose,
  file,
}: ModalProps): JSX.Element {
  const { toastNotify } = useContext(AppContext);
  const [sample, setSample] = useState({
    url: "",
    file: null,
    type: null,
    buffer: null,
  });

  //   const getFile = useCallback(async () => {
  //     try {
  //       if (file?._id) {
  //         const response: any = await appRequest("filesystem", "get", {
  //           id: file._id,
  //         });
  //         if (response) {
  //           if (response?.error) {
  //           } else {
  //             let buffer =
  //               typeof response === "string" ? JSON.parse(response) : response;
  //             buffer = new Uint8Array(buffer);

  //             const fileURL = URL.createObjectURL(
  //               new Blob([buffer], { type: file.metadata.contentType })
  //             );
  //             setSample({
  //               url: fileURL,
  //               file: file,
  //               type: file.metadata.contentType,
  //               buffer: buffer,
  //             });
  //           }
  //         }
  //       }
  //     } catch (error: any) {
  //       toastNotify({
  //         title: "Error",
  //         message: error.message,
  //         type: "error",
  //       });
  //     }
  //   }, [toastNotify, file]);

  //   useEffect(() => {
  //     if (isOpen) {
  //       getFile();
  //     }
  //   }, [isOpen, getFile]);

  useEffect(() => {
    setSample({ url: "", file: null, type: null, buffer: null });
  }, [onClose]);

  const viewerWidth = useBreakpointValue({ lg: true });

  let width = "95vw";

  const handleModalWheel = (event: React.WheelEvent<HTMLDivElement>) => {
    event.stopPropagation();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="full" isCentered>
      <ModalOverlay bg="rgba(0, 0, 0, 0.2)" />
      <ModalContent
        position="fixed"
        right={isOpen ? "0" : `-${width}`}
        top="0"
        height="100vh"
        width={viewerWidth ? width : "100vw"}
        animation={`${
          isOpen ? "slideIn" : "slideOut"
        } 0.8s ease-in-out forwards`}
      >
        <ModalHeader
          fontSize={{ base: "md", lg: "xl" }}
          color="teal.300"
          fontWeight="700"
        >
          Document
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody
          px={{ base: ".5rem", lg: "1.5rem" }}
          overflowY="auto"
          className="customScrollBar"
          mb={{ base: "1rem", lg: "unset" }}
        >
          <Box
            display={{ base: "grid", lg: "flex" }}
            flexDirection={{ base: "column", lg: "row" }}
            gap={{ base: 1, lg: 6 }}
            h="90%"
          >
            <Box
              h={{ base: "30vh", md: "40vh", lg: "80vh" }}
              mb="1rem"
              w="100%"
            >
              {/* <FileViewer sample={sample} /> */}
              <embed
                width="100%"
                height="100%"
                className="customScrollBar"
                src="img/FILE988505112023063018070.pdf"
                type="application/pdf"
              ></embed>
            </Box>
            {/* {values && ( */}
            <Box
              h="80vh"
              w={{ lg: "120vw" }}
              p={{ base: ".6rem", lg: "1.5rem .6rem" }}
              overflowY="auto"
              className="customScrollBar"
              onWheel={handleModalWheel}
              border="2px solid"
              borderColor="teal.400"
              rounded={4}
            >
              <CurbeyTable />
            </Box>
          </Box>
        </ModalBody>
      </ModalContent>
      <style>
        {`
          @keyframes slideIn {
            from {
              right: -${width};
            }
            to {
              right: 0;
            }
          }

          @keyframes slideOut {
            from {
              right: 0;
            }
            to {
              right: -${width};
            }
          }
          `}
      </style>
    </Modal>
  );
}
